import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { EventsService } from 'app/shared/services/events/events.service';
import { LoginFailedService } from 'app/shared/services/login-failed/login-failed.guard.service';
import { UserSessionsService } from 'app/shared/services/user-sessions/user-sessions.service';
import { IUserProfile } from 'app/interfaces/user-profile.interface';
import { Subject, takeUntil } from 'rxjs';

import { RenewalPopupComponent } from '../renewal-popup/renewal-popup.component';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  selector: 'app-login',
  templateUrl: './login-failed.component.html',
  styleUrls: ['./login-failed.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RenewalPopupComponent, LoaderComponent],
})
export class LoginFailedComponent implements OnInit, OnDestroy {
  showLoader: boolean = false;
  isShowRenewalPopup: boolean = false;
  userProfile: IUserProfile | null = null;
  private ngDestroy$ = new Subject<void>();
  private eventsService: EventsService = inject(EventsService);
  public loginFailedService: LoginFailedService = inject(LoginFailedService);
  private userSessionService: UserSessionsService = inject(UserSessionsService);

  ngOnInit() {
    this.eventsService.showLoader$.pipe(takeUntil(this.ngDestroy$)).subscribe({
      next: (status) => {
        this.showLoader = status;
      },
    });
    this.userSessionService.isShowRenewalPopup.pipe(takeUntil(this.ngDestroy$)).subscribe({
      next: (userProfile) => {
        this.isShowRenewalPopup = false;
        if (userProfile) {
          this.isShowRenewalPopup = true;
          this.userProfile = userProfile;
        }
      },
    });
  }

  ngOnDestroy() {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }
}
